import DeliveryFields from "./DeliveryFields.js";
import ComposeTimeline from "./ComposeTimeline.js";
import "./ComposeTimelinePanel.css";

/**
 * Full-width timeline panel for advanced mode - sits below the two-column
 * preview/sidebar grid rather than inside it. A multi-row visual timeline
 * needs real horizontal space (a ruler plus every layer's animation bars),
 * which the previous, narrow 22rem sidebar location couldn't reasonably
 * provide - this also reclaims screen space that sat unused below the
 * canvas before.
 */
export default function ComposeTimelinePanel({
  doc,
  selectedLayerId,
  onSelectLayer,
  editable,
  onSetDeliveryProfile,
  onReplay,
  onScrub,
  onUpdateLayer,
}) {
  return (
    <div className="compose-timeline-panel">
      <div className="compose-timeline-panel__row">
        <DeliveryFields doc={doc} onChange={onSetDeliveryProfile} disabled={!editable} />
        <button type="button" onClick={onReplay} className="compose-page__replay-btn">
          Replay
        </button>
      </div>
      <ComposeTimeline
        doc={doc}
        selectedLayerId={selectedLayerId}
        onSelectLayer={onSelectLayer}
        onScrub={onScrub}
        onUpdateLayer={onUpdateLayer}
        editable={editable}
      />
    </div>
  );
}